import React from 'react';
import { Container } from 'components/layout/Container';
import ProductHero from '../../components/product/productHero/ProductHero';
import ProductBottom from '../../components/product/productBottom/ProductBottom';
import './_Product.scss';

const Product = () => (
  <>
    <Container>
      <ProductHero />
    </Container>
    <ProductBottom />
  </>
);

export default Product;
